import styled from 'styled-components';

import { Badge } from 'ui/badge';
import { GRAPHQL_TYPENAMES } from 'modules/graphql/types';
import { WorkflowStatusBadge } from 'modules/workflowIndex/components/WorkflowsTable/WorkflowStatusBadge';
import { BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES } from 'modules/campaignIndex/constants';

import { Cell } from './table/Cell';
import { PlaceholderText } from './PlaceholderText';
import { TABLE_COLUMNS } from './constants';
import { ListReference } from '../../../types';

type ListReferenceStatusCellProps = {
  listReference: ListReference;
  rowIndex: number;
};

const StyledBadge = styled(Badge)`
  width: fit-content;
`;

export const testIds = {
  cell: 'segmentation-lrsc-cell',
};

export const ListReferenceStatusCell = ({
  listReference: dependent,
  rowIndex,
}: ListReferenceStatusCellProps) => {
  if (dependent.__typename === GRAPHQL_TYPENAMES.CAMPAIGN) {
    return (
      <Cell
        data-test={testIds.cell}
        columnId={TABLE_COLUMNS.STATUS}
        {...(rowIndex % 2 === 0 && { className: 'shadedRow' })}
      >
        <StyledBadge variant={BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES[dependent.campaignState]}>
          {dependent.campaignState}
        </StyledBadge>
      </Cell>
    );
  }

  if (dependent.__typename === GRAPHQL_TYPENAMES.JOURNEY) {
    return (
      <Cell
        data-test={testIds.cell}
        columnId={TABLE_COLUMNS.STATUS}
        {...(rowIndex % 2 === 0 && { className: 'shadedRow' })}
      >
        <WorkflowStatusBadge workflow={dependent} />
      </Cell>
    );
  }

  return (
    <Cell
      data-test={testIds.cell}
      columnId={TABLE_COLUMNS.STATUS}
      {...(rowIndex % 2 === 0 && { className: 'shadedRow' })}
    >
      <PlaceholderText>N/A</PlaceholderText>
    </Cell>
  );
};
